const ACTIONS_KEYS = new Set(['actions', 'action', 'properties_action']);

function isActionsColumn(column) {
  if (!column) return false;
  return (
    ACTIONS_KEYS.has(column.key) ||
    ACTIONS_KEYS.has(column.dataIndex) ||
    (Array.isArray(column.dataIndex) &&
      column.dataIndex.some((key) => ACTIONS_KEYS.has(key)))
  );
}

/**
 * Pin Actions columns to the right so they stay visible while the table
 * scrolls horizontally (needed on medium / tablet viewports).
 *
 * Ant Design only enables sticky columns when `scroll.x` is set on the Table.
 */
export function pinActionsColumn(columns = []) {
  if (!Array.isArray(columns)) return columns;

  return columns.filter(Boolean).map((column) => {
    if (!isActionsColumn(column)) return column;
    if (column.fixed != null) return column;
    return {
      ...column,
      fixed: 'right',
    };
  });
}

/**
 * Ensure Table has a horizontal scroll target so `fixed` columns work.
 */
export function withTableScroll(scroll, fallbackX = 'max-content') {
  if (scroll === false) return undefined;
  if (scroll == null) return { x: fallbackX };
  if (typeof scroll === 'object' && scroll.x == null) {
    return { ...scroll, x: fallbackX };
  }
  return scroll;
}
